<template>
    <div>
        <rkm-alert
            v-if="form.isResponsavel"
            color="info"
        >
            <span>Paciente é o responsável.</span>
        </rkm-alert>

        <rkm-alert
            v-if="!form.isUnidadeReferencia"
            color="warning"
        >
            <span>A Unidade de referência selecionada deixou de ser uma unidade referência. Atribua uma nova unidade.</span>
        </rkm-alert>

        <rkm-alert
            v-if="form && form.atualizacao"
            :color="form.diasAtrasados ? 'danger' : 'success'"
        >
            <span><strong>Última atualização:</strong> {{ form.atualizacao }}</span>
            <span v-if="form.diasAtrasados" class="pl-1">
                (cadastro desatualizado há <strong>{{ form.diasAtrasados }}</strong> {{ form.diasAtrasados > 1 ? 'dias' : 'dia'}})
            </span>
        </rkm-alert>

        <rkm-tabs
            v-model="tabIndex"
            :tab-refs="tabRefs"
        >
            <rkm-tab
                active
                title="Dados do paciente"
            >
                <TabIdentificacao
                    ref="TabIdentificacao"
                    :form="form"
                    :model="model"
                />
            </rkm-tab>

            <rkm-tab title="Documentações">
                <TabDocumentos
                    ref="TabDocumentos"
                    :form="form"
                    :model="model"
                />
            </rkm-tab>

            <rkm-tab title="Unidade/Equipe de referência">
                <TabIdentificacaoSaude
                    ref="TabIdentificacaoSaude"
                    :form="form"
                    :model="model"
                />
            </rkm-tab>

            <rkm-tab title="Questionário de saúde">
                <TabQuestionarioSaude
                    ref="TabQuestionarioSaude"
                    :form="form"
                    :model="model"
                />
            </rkm-tab>

            <rkm-tab title="Informações sociais">
                <TabInformacoesSociais
                    ref="TabInformacoesSociais"
                    :form="form"
                    :model="model"
                />
            </rkm-tab>
        </rkm-tabs>
    </div>
</template>

<script>

// Others.
import moment from 'moment'

// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { cadastroCidadaoForm, repository, error, stringCase, object } from '@/mixins'

// Components.
import TabIdentificacao from '@/components/cadastro/paciente/tabs/Identificacao'
import TabDocumentos from '@/components/cadastro/paciente/tabs/Documentos'
import TabIdentificacaoSaude from '@/components/cadastro/paciente/tabs/IdentificacaoSaude'
import TabQuestionarioSaude from '@/components/cadastro/paciente/tabs/QuestionarioSaude'
import TabInformacoesSociais from '@/components/cadastro/paciente/tabs/InformacoesSociais'

export default {
    components: {
        TabIdentificacao,
        TabDocumentos,
        TabIdentificacaoSaude,
        TabQuestionarioSaude,
        TabInformacoesSociais,
    },
    mixins: [ cadastroCidadaoForm, repository, error, stringCase, object ],
    props: {
        id: { type: Number },
    },
    data: () => ({
        tabIndex: 0,
        tabRefs: [],
        repositories: {
            paciente: null,
        },
        form: {
            exibeConfirmacaoClassificacao: false,
            termosInvalidos: [],
            dataAtual: '',
            classificacoes: [],
            subclassificacoes: [],
            unidadesReferencia: [],
            prontuario: null,
            isResponsavel: false,
            isUnidadeReferencia: true,
            isPermissaoEndereco: null,
            isPermissaoBloquear: null,
            bloqueado: [],
            atualizacao: null,
            diasAtrasados: null,
            historico: [],
            impressoes: [],
            acompanhamentoInfantil: [],
            curso: [],
            mercadoTrabalho: [],
            orientacaoSexual: [],
            deficiencia: [],
            peso: [],
            doencasCardiacas: [],
            problemasRins: [],
            doencasRespiratorias: [],
            saidaCidadao: [],
            imovelTipo: [],
            situacaoDomicilio: [],
            domicilioTipo: [],
            situacaoRural: [],
            zonas: [],
            domicilioTipoAcesso: [],
            materialPredominante: [],
            abastecimento: [],
            tratamento: [],
            destinoLixo: [],
            formaEscoamento: [],
            higieneResidencial: [],
            animais: [],
            escalaCoelho: [],
            lazer: [],
            microareas: [],
            parentesco: [],
            residentes: [],
            domicilioId: [],
            responsaveis: [],
        },
        model: {
            id: null,
            cadastroSimplificado: false,
            email: '',
            classificacaoId: null,
            subclassificacaoId: null,
            periodoValidade: {
                start: null,
                end: null,
            },
            prontuarioUnidade: '',
            unidadeId: null,
            responsavelUsuario: null,
            responsavelInfraestruturaId: null,
            responsavelUnidadeId: null,
            responsavelEquipeId: null,
            responsavelOcupacaoId: null,
            responsavelData: null,
            responsaveis: [],
            bloqueado: false,
            impressoes: [],
            imovelTipoId: [],
            situacaoDomicilioId: [],
            domicilioTipoId: [],
            quantidadeComodos: [],
            situacaoRuralId: null,
            domicilioZonaId: null,
            domicilioTipoAcessoId: null,
            materialPredominanteId: null,
            abastecimentoId: null,
            tratamentoId: null,
            destinoLixoId: null,
            formaEscoamentoId: null,
            possuiAnimais: null,
            energiaEletrica: null,
            quantidadeAnimais: null,
            animal: [],
            instituicaoNome: null,
            instituicaoOutrosProfissionais: null,
            instituicaoNomeResponsavelTecnico: null,
            instituicaoCnsResponsavelTecnico: null,
            instituicaoCargoResponsavelTecnico: null,
            instituicaoTelefoneResponsavelTecnico: null,
            escalaCoelhoId: null,
            higieneResidencialId: null,
            bolsaFamilia: null,
            valeGas: null,
            bolsaEscola: null,
            lazer: null,
            bpc: null,
            foraArea: false,
            microareaId: null,
            rendaMensal: null,
            originalRendaMensal: null,
            rendaTotalFamiliar: null,
            ocupacao: null,
            cursoId: null,
            frequentaEscolaCreche: null,
            situacaoMercadoTrabalhoId: null,
            frequentaCuidadorTradicional: null,
            participaGrupoComunitario: null,
            acompanhamentoInfantil: null,
            planoSaude: null,
            convenioMedico: null,
            comunidadeTradicional: null,
            saidaCidadaoId: null,
            motivoSaidaData: null,
            obito: null,
            obitoEm: null,
            horaObito: null,
            obitoDeclaracao: null,
            obitoCausa: null,
            obitoCid: null,
            parentescoId: null,
            pesoId: null,
            internacao: null,
            internacaoMotivo: null,
            doencaCardiaca: null,
            doencaCardiacaQuais: null,
            problemasRins: null,
            problemasRinsQuais: null,
            doencaRespiratoria: null,
            doencaRespiratoriaQuais: null,
            tratamentoSaudeMental: null,
            acamado: null,
            domiciliado: null,
            plantasMedicinais: null,
            plantasMedicinaisQuais: null,
            deficiente: null,
            orientacaoSexual: null,
            orientacaoSexualId: null,
            identidadeGenero: null,
            outrasCondicoesPrimaria: null,
            outrasCondicoesSecundaria: null,
            outrasCondicoesTerciaria: null,
            possuiVeiculoProprio: false,
            possuiFinanciamento: false,
            possuiEmprestimo: false,
            recusaCadastro: false,
            dataUltimaMenstruacao: null,
            idadeGestacionalSemanas: null,
            idadeGestacionalDias: null,
            dataPossivelParto: null,
            gravidezPlanejada: null,
            gestacaoPrevia: null,
            parto: null,
            responsavel: null,
            responsavelCidadaoId: null,
            parentescoResponsavelId: null,
            comunidadeTradicionalQual: null,
            informacaoSocialRecusaCadastro: null,
            informacaoResidencialRecusaCadastro: null,
            praticasIntegrativas: null,
            veiculos: [],
            financiamentos: [],
            emprestimos: [],
        },
        others: {moment},
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            const request = this.id
                ? this.repositories.paciente.edit(this.id)
                : this.repositories.paciente.create()

            request
                .then(({ data }) => this.setData(data.form, data.model || null))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        setData(form, model) {

            if (form.cidadao) {

                this.setCidadaoData(form.cidadao, model ? model.cidadao : null)
            }

            this.form.termosInvalidos = form.termosInvalidos
            this.form.dataAtual = form.dataAtual
            this.form.classificacoes = form.classificacoes
            this.form.subclassificacoes = form.subclassificacoes
            this.form.unidadesReferencia = form.unidadesReferencia
            this.form.prontuario = form.prontuario
            this.form.isResponsavel = form.isResponsavel
            this.form.isUnidadeReferencia = form.isUnidadeReferencia
            this.form.isPermissaoEndereco = form.isPermissaoEndereco
            this.form.isPermissaoBloquear = form.isPermissaoBloquear
            this.form.bloqueado = form.bloqueado
            this.form.atualizacao = form.atualizacao
            this.form.diasAtrasados = form.diasAtrasados
            this.form.historico = form.historico
            this.form.impressoes = form.impressoes
            this.form.acompanhamentoInfantil = form.acompanhamentoInfantil
            this.form.curso = form.curso
            this.form.mercadoTrabalho = form.mercadoTrabalho
            this.form.deficiencia = form.deficiencia
            this.form.peso = form.peso
            this.form.saidaCidadao = form.saidaCidadao
            this.form.imovelTipo = form.imovelTipo
            this.form.situacaoDomicilio = form.situacaoDomicilio
            this.form.domicilioTipo = form.domicilioTipo
            this.form.situacaoRural = form.situacaoRural
            this.form.zonas = form.zonas
            this.form.domicilioTipoAcesso = form.domicilioTipoAcesso
            this.form.materialPredominante = form.materialPredominante
            this.form.abastecimento = form.abastecimento
            this.form.tratamento = form.tratamento
            this.form.destinoLixo = form.destinoLixo
            this.form.formaEscoamento = form.formaEscoamento
            this.form.higieneResidencial = form.higieneResidencial
            this.form.animais = form.animais
            this.form.escalaCoelho = form.escalaCoelho
            this.form.lazer = form.lazer
            this.form.microareas = form.microareas
            this.form.parentesco = form.parentesco
            this.form.residentes = form.residentes
            this.form.domicilioId = form.domicilioId
            this.form.orientacaoSexual = form.orientacaoSexual

            this.form.peso = form.peso
            this.form.doencasCardiacas = form.doencasCardiacas
            this.form.problemasRins = form.problemasRins
            this.form.doencasRespiratorias = form.doencasRespiratorias
            this.form.responsaveis = form.responsaveis

            if (!model) {

                this.form.exibeConfirmacaoClassificacao = true

                return
            }

            this.model.id = this.id
            this.model.email = model.email
            this.model.classificacaoId = model.classificacaoId

            this.$nextTick()
                .then(() => {

                    this.model.subclassificacaoId = model.subclassificacaoId
                    this.model.periodoValidade.start = model.validadeInicio
                    this.model.periodoValidade.end = model.validadeFim
                    this.model.prontuarioUnidade = model.prontuarioUnidade
                    this.model.unidadeId = model.unidadeId
                    this.model.bloqueado = model.bloqueado ? true : false
                    this.model.prontuariosUnidades = model.prontuariosUnidades
                    this.model.impressoes = model.impressoes

                    this.model.responsavelUsuario = model.responsavelUsuario

                    return this.$nextTick()
                })
                .then(() => {

                    this.model.responsavelUnidadeId = model.responsavelUnidadeId

                    return this.$nextTick()
                })
                .then(() => {

                    this.model.responsavelInfraestruturaId = model.responsavelInfraestruturaId

                    return this.$nextTick()
                })
                .then(() => {

                    this.model.responsavelEquipeId = model.responsavelEquipeId

                    return this.$nextTick()
                })
                .then(() => {

                    this.model.responsavelOcupacaoId = model.responsavelOcupacaoId
                    this.model.responsavelData = model.responsavelData

                    this.model.responsaveis = model.responsaveis
                    this.model.imovelTipoId = model.imovelTipoId
                    this.model.situacaoDomicilioId = model.situacaoDomicilioId
                    this.model.domicilioTipoId = model.domicilioTipoId
                    this.model.quantidadeComodos = model.quantidadeComodos
                    this.model.situacaoRuralId = model.situacaoRuralId
                    this.model.domicilioZonaId = model.domicilioZonaId
                    this.model.domicilioTipoAcessoId = model.domicilioTipoAcessoId
                    this.model.materialPredominanteId = model.materialPredominanteId
                    this.model.abastecimentoId = model.abastecimentoId
                    this.model.tratamentoId = model.tratamentoId
                    this.model.destinoLixoId = model.destinoLixoId
                    this.model.formaEscoamentoId = model.formaEscoamentoId
                    this.model.possuiAnimais = model.possuiAnimais
                    this.model.energiaEletrica = model.energiaEletrica
                    this.model.quantidadeAnimais = model.quantidadeAnimais
                    this.model.animal = model.animal
                    this.model.instituicaoNome = model.instituicaoNome;
                    this.model.instituicaoOutrosProfissionais = model.instituicaoOutrosProfissionais;
                    this.model.instituicaoNomeResponsavelTecnico = model.instituicaoNomeResponsavelTecnico;
                    this.model.instituicaoCnsResponsavelTecnico = model.instituicaoCnsResponsavelTecnico;
                    this.model.instituicaoCargoResponsavelTecnico = model.instituicaoCargoResponsavelTecnico;
                    this.model.instituicaoTelefoneResponsavelTecnico = model.instituicaoTelefoneResponsavelTecnico;
                    this.model.escalaCoelhoId = model.escalaCoelhoId
                    this.model.higieneResidencialId = model.higieneResidencialId
                    this.model.bolsaFamilia = model.bolsaFamilia
                    this.model.valeGas = model.valeGas
                    this.model.bolsaEscola = model.bolsaEscola
                    this.model.lazer = model.lazer
                    this.model.bpc = model.bpc
                    this.model.foraArea = model.foraArea
                    this.model.microareaId = model.microareaId
                    this.model.rendaMensal = model.rendaMensal
                    this.model.originalRendaMensal = model.rendaMensal
                    this.model.rendaTotalFamiliar = model.rendaTotalFamiliar
                    this.model.ocupacao = model.ocupacao
                    this.model.recusaCadastro = model.recusaCadastro

                    this.model.responsavel = model.responsavel;
                    this.model.responsavelCidadaoId = model.responsavelCidadaoId;
                    this.model.parentescoResponsavelId = model.parentescoResponsavelId;
                    this.model.cursoId = model.cursoId
                    this.model.frequentaEscolaCreche = model.frequentaEscolaCreche
                    this.model.situacaoMercadoTrabalhoId = model.situacaoMercadoTrabalhoId
                    this.model.frequentaCuidadorTradicional = model.frequentaCuidadorTradicional
                    this.model.comunidadeTradicionalQual = model.comunidadeTradicionalQual;
                    this.model.participaGrupoComunitario = model.participaGrupoComunitario
                    this.model.acompanhamentoInfantil = model.acompanhamentoInfantil
                    this.model.planoSaude = model.planoSaude
                    this.model.convenioMedico = model.convenioMedico
                    this.model.comunidadeTradicional = model.comunidadeTradicional
                    this.model.saidaCidadaoId = model.saidaCidadaoId
                    this.model.motivoSaidaData = model.motivoSaidaData
                    this.model.obito = model.obito
                    this.model.obitoEm = model.obitoEm
                    this.model.horaObito = model.horaObito
                    this.model.obitoDeclaracao = model.obitoDeclaracao
                    this.model.obitoCausa = model.obitoCausa
                    this.model.obitoCid = model.obitoCid
                    this.model.informacaoSocialRecusaCadastro = model.informacaoSocialRecusaCadastro;

                    this.model.pesoId = model.pesoId;
                    this.model.internacao = model.internacao;
                    this.model.internacaoMotivo = model.internacaoMotivo;
                    this.model.doencaCardiaca = model.doencaCardiaca;
                    this.model.doencaCardiacaQuais = model.doencaCardiacaQuais;
                    this.model.problemasRins = model.problemasRins;
                    this.model.problemasRinsQuais = model.problemasRinsQuais;
                    this.model.doencaRespiratoria = model.doencaRespiratoria;
                    this.model.doencaRespiratoriaQuais = model.doencaRespiratoriaQuais;
                    this.model.tratamentoSaudeMental = model.tratamentoSaudeMental;
                    this.model.acamado = model.acamado;
                    this.model.deficiente = model.deficiente;
                    this.model.orientacaoSexual = model.orientacaoSexual;
                    this.model.orientacaoSexualId = model.orientacaoSexualId;
                    this.model.identidadeGenero = model.identidadeGenero;
                    this.model.domiciliado = model.domiciliado;
                    this.model.plantasMedicinais = model.plantasMedicinais;
                    this.model.plantasMedicinaisQuais = model.plantasMedicinaisQuais;
                    this.model.outrasCondicoesPrimaria = model.outrasCondicoesPrimaria;
                    this.model.outrasCondicoesSecundaria = model.outrasCondicoesSecundaria;
                    this.model.outrasCondicoesTerciaria = model.outrasCondicoesTerciaria;
                    this.model.possuiVeiculoProprio = model.possuiVeiculoProprio;
                    this.model.possuiFinanciamento = model.possuiFinanciamento;
                    this.model.possuiEmprestimo = model.possuiEmprestimo;
                    this.model.dataUltimaMenstruacao = model.dataUltimaMenstruacao;
                    this.model.idadeGestacionalSemanas = model.idadeGestacionalSemanas;
                    this.model.idadeGestacionalDias = model.idadeGestacionalDias;
                    this.model.dataPossivelParto = model.dataPossivelParto;
                    this.model.gravidezPlanejada = model.gravidezPlanejada;
                    this.model.gestacaoPrevia = model.gestacaoPrevia;
                    this.model.parto = model.parto;
                    this.model.veiculos = model.veiculos;
                    this.model.financiamentos = model.financiamentos;
                    this.model.emprestimos = model.emprestimos;
                    this.model.praticasIntegrativas = model.praticasIntegrativas;
                    this.model.informacaoResidencialRecusaCadastro = model.informacaoResidencialRecusaCadastro;

                    this.form.exibeConfirmacaoClassificacao = true
                })
        },
        async validate() {

            const currentValid = await this.tabRefs[this.tabIndex].validate()

            if (!currentValid) {

                return false;
            }

            let valid = true

            for (let i = 0; i < this.tabRefs.length; i++) {

                if (i !== this.tabIndex) {

                    valid = await this.tabRefs[i].validate()

                    if (!valid) {

                        this.tabIndex = i

                        break
                    }
                }
            }

            return valid
        },
        save() {

            this.validate()
                .then(valid => {

                    if (!valid) return

                    this.setLoading()


                    this.repositories.paciente.update(this.id, this.prepareData())
                        .then(({ data }) => {

                            this.showSaveNotification()
                            this.$emit('save', data)
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        prepareData() {

            const paciente = this.clone(this.model)

            delete paciente.id

            paciente.validadeInicio = this.model.periodoValidade.start
                ? this.others.moment(this.model.periodoValidade.start).format('YYYY-MM-DD') : null
            paciente.validadeFim = this.model.periodoValidade.end
                ? this.others.moment(this.model.periodoValidade.end).format('YYYY-MM-DD') : null
            paciente.responsavelData = this.model.responsavelData
                ? this.others.moment(this.model.responsavelData).format('YYYY-MM-DD') : null
            paciente.dataUltimaMenstruacao = this.model.dataUltimaMenstruacao
                ? this.others.moment(this.model.dataUltimaMenstruacao).format('YYYY-MM-DD') : null
            paciente.motivoSaidaData = this.model.motivoSaidaData
                ? this.others.moment(this.model.motivoSaidaData).format('YYYY-MM-DD') : null
            paciente.internacaoData = this.model.internacaoData
                ? this.others.moment(this.model.internacaoData).format('YYYY-MM-DD') : null
            paciente.tratamentoSaudeMentalInternacaoData = this.model.tratamentoSaudeMentalInternacaoData
                ? this.others.moment(this.model.tratamentoSaudeMentalInternacaoData).format('YYYY-MM-DD') : null
            paciente.tratamentoSaudeMentalAltaData = this.model.tratamentoSaudeMentalAltaData
                ? this.others.moment(this.model.tratamentoSaudeMentalAltaData).format('YYYY-MM-DD') : null

            paciente.obitoEm = this.model.obitoEm
                ? this.others.moment(this.model.obitoEm).format('DD/MM/YYYY') + ' ' + paciente.horaObito
                : null

            paciente.comunidadeTradicionalId = this.model.comunidadeTradicionalQual ? this.model.comunidadeTradicionalQual.id : null
            paciente.ocupacaoId = this.model.ocupacao ? this.model.ocupacao.id : null
            paciente.obitoCidId = this.model.obitoCid ? this.model.obitoCid.id : null

            paciente.rendaMensal = this.parseValue(this.model.rendaMensal)
            paciente.rendaTotalFamiliar = this.parseValue(this.model.rendaTotalFamiliar)

            delete paciente.periodoValidade

            paciente.cidadao = this.prepareCidadaoData()
            paciente.origem = 'cadastroPaciente'

            return this.camelObjectKeysToSnakeRecursive(paciente)
        },
        parseValue($value) {
            return parseFloat($value.replace('.', '').replace(',', '.'))
        },
    },
    created() {

        this.repositories.paciente = this.getConectaSusRepository('cadastro.sujeitoAtencao.paciente')

        this.load()
    },
    mounted() {

        this.tabRefs = [
            this.$refs.TabIdentificacao,
            this.$refs.TabDocumentos,
            this.$refs.TabIdentificacaoSaude,
            this.$refs.TabQuestionarioSaude,
            this.$refs.TabInformacoesSociais,
        ]
    }
}
</script>